module.exports = __webpack_public_path__ + "img/ccc.80cc597a.png";